import { format } from 'date-fns'
import { date, nullable, pipe, string, transform } from 'valibot'

// Date→string型への変換を含む、時間のnullableなスキーマ
export const nullableTimeToStringSchema = pipe(
  nullable(date()),
  // Date型だった場合stringに変換
  transform((v) => (v instanceof Date ? format(v, 'HH:mm') : null)),
  nullable(string())
)
